// extracted by mini-css-extract-plugin
export default {"dialog":"SessionExpiredDialog_dialog__hHS5C","title":"SessionExpiredDialog_title__k5JoD","text":"SessionExpiredDialog_text__TZOmm","footer":"SessionExpiredDialog_footer__JI+jp"};